module.exports = __webpack_public_path__ + "img/rank2_2.0c34a5e0.png";